import { createFileRoute } from "@tanstack/react-router";
import { MagicLinkPage } from "../features/auth/MagicLinkPage";

export const Route = createFileRoute("/auth/magic")({
  validateSearch: (
    s: Record<string, unknown>,
  ): { token: string; client?: string; next?: string; browser?: boolean } => ({
    token: typeof s.token === "string" ? s.token : "",
    // The link said it is for the browser. iOS honours the same flag through the
    // site's apple-app-site-association, which is what let this page load at all.
    ...(s.browser === "1" || s.browser === true ? { browser: true } : {}),
    ...(typeof s.client === "string" && s.client ? { client: s.client } : {}),
    // Only a path on this origin: a sign-in link that could be pointed anywhere is an
    // open redirect that anyone can aim by asking for somebody else's mail.
    ...(typeof s.next === "string" && s.next.startsWith("/") && !s.next.startsWith("//")
      ? { next: s.next }
      : {}),
  }),
  component: () => {
    const { token, client, next, browser } = Route.useSearch();
    return <MagicLinkPage token={token} client={client} next={next} browser={browser} />;
  },
});
